/* eslint-disable */
import React, { useEffect, useState } from "react";
import { ACTIVITY, ENTITYNAME, LOCALSTORAGE_KEY, TOAST_TYPES } from "../../framework/constant/constant";
import * as API from "../../framework/API/api";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { utility } from "../../framework/utility/utilityProvider";
import { useTranslation } from "../../locale/useTranslation";
import BossDialog from "../../components/BossDialog";
import { TimePickerWithFormat } from "../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { TimeCell } from "../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import moment from "moment";
import CopySlotPrototypeEditForm from "./CopySlotPrototypeEditForm";
import ToastNotification from "../../components/ToastNotification";

export const CopySlotsForm = (props) => {

  const preferenceData = utility.getValue(LOCALSTORAGE_KEY.planningpreference);
  const offSetHours = new Date(preferenceData?.data[0]?.value?.TimeZone?.DayStartTime ?? 0).getUTCHours();
  const offsetTime = offSetHours * 3600000;

  const primarystarttime = preferenceData?.data[0]?.value?.TimeZone?.PrimeStartTime;
  const primaryendtime = preferenceData?.data[0]?.value?.TimeZone?.PrimeEndTime;
  const fromDate = moment(props.plannerPayload.date).startOf('isoWeek').format('YYYY-MM-DD');
  const fromTime = primarystarttime ? utility.convertMilisecondsToStringWithFrames(primarystarttime) : '00:00:00:00';
  const toDate = moment(props.plannerPayload.date).endOf('isoWeek').format('YYYY-MM-DD');
  const toTime =  primaryendtime ? utility.convertMilisecondsToStringWithFrames(primaryendtime) : '23:59:59:00';

  var defaultDataItem = {
    Name: '',
    FromDate: fromDate,
    FromTime: fromTime,
    ToTime: toTime,
    ToDate: toDate,
    Channel: props.plannerPayload.channels[0],
    CopySlotPrototype: "",
    Activity: ACTIVITY[0],
    Move: false
  }

  const [dataItem, setDataItem] = useState(defaultDataItem);

  const [channel, setChannel] = useState([]);
  const [copySlotPrototype, setCopySlotPrototype] = useState([]);
  const [copyslotsPrototypeData, setCopyslotsPrototypeData] = useState([]);
  const lang = useTranslation();
  const [showCopySlotProtoType, setShowCopySlotProtoType] = useState(false);
  const [disable, setDisable] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');
  const [selectedCopySlotPrototype, setSelectedCopySlotPrototype] = useState(null);

  useEffect(() => {
    loadcombo();
  }, []);

  function getMinimumTimeForDayBufferZero(slots = []) {

  const validSlots = slots.filter(
    x => Number(x.DayBuffer) === 0
  );

  if (validSlots.length === 0) {
    return null;
  }

  return Math.min(
    ...validSlots.map(x => Number(x.SlotStartTime))
  );
}

  const isValid = () => {

    if (Object.keys(dataItem.Channel).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
      setDisable(false);
      return false;
    }

    const fromTimeMs = utility.convertStringTimeToMilliseconds(dataItem.FromTime);
    const toTimeMs = utility.convertStringTimeToMilliseconds(dataItem.ToTime);
    
    const diffInHours = (toTimeMs - fromTimeMs) / (1000 * 60 * 60);

    if(fromTimeMs > toTimeMs){
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.from_time_should_be_less_than_To_time_booking_error_message });
      setDisable(false);
      return false
    }

    if (diffInHours > 6) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.time_range_difference_error_message });
      setDisable(false);
      return false
    }

    if(!dataItem.CopySlotPrototype || Object.keys(dataItem.CopySlotPrototype).length == 0){
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_copy_slot_prototype_error_message });
      setDisable(false);
      return false
    }

    if(dataItem.CopySlotPrototype && dataItem.CopySlotPrototype.Slots && dataItem.CopySlotPrototype.Slots.length == 0){
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_slots_found_to_copy_error_message });
      setDisable(false);
      return false
    }

    //Add validation if day buffer in zero and slot start time is less than day buffer
    if (dataItem.CopySlotPrototype?.Slots?.length > 0) {

      const minimumSlot = getMinimumTimeForDayBufferZero(dataItem.CopySlotPrototype.Slots);

      const isInvalidSameDaySlot = minimumSlot &&  minimumSlot < toTimeMs;

      if (isInvalidSameDaySlot) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.slot_start_time_is_less_than_day_buffer_error_message });
        setDisable(false);
        return false;
      }
    }

    //Add validation range differnece between copy slot and copied slot
    if (
      dataItem.CopySlotPrototype &&
      Array.isArray(dataItem.CopySlotPrototype.Slots) &&
      dataItem.CopySlotPrototype.Slots.length > 0
    ) {

      const slots = dataItem.CopySlotPrototype.Slots;

      const expectedDiff = diffInHours * 60 * 60 * 1000;

      for (let i = 0; i < slots.length - 1; i++) {

        const currentSlot = slots[i];
        const nextSlot = slots[i + 1];

        // CHECK ONLY SAME DAY BUFFER
        if ( Number(currentSlot.DayBuffer) == Number(nextSlot.DayBuffer)) {

          const actualDiff = nextSlot.SlotStartTime - currentSlot.SlotStartTime;

          // SHOULD NOT BE LESS THAN RANGE DIFF
          if (actualDiff < expectedDiff) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.mismatch_in_selected_time_range_and_slots_time_range_error_message });
            setDisable(false);
            return false;
          }
        }
      }

      return true;
    }

    return true;
  };

  const loadcombo = async () => {

    let copySlotPrototypeRes = await API.getDataLookup(ENTITYNAME.CopySlotPrototype, { sort: { Description: 1 }, });
    setCopySlotPrototype(copySlotPrototypeRes.data);

    let channelRes = await API.getValidChannels(ENTITYNAME.Channel);
    setChannel(channelRes.data);

    if (dataItem?.CopySlotPrototype?._id) {
      const foundPrototype = copySlotPrototypeRes.data.find(item => item?._id?.toString() === dataItem?.CopySlotPrototype?._id?.toString());
      setCopyslotsPrototypeData(foundPrototype?.Slots || []);
    }

  };

  const onChange = (e) => {
    const { name, value } = e.target;
    if (name === "CopySlotPrototype") {
      const selected = copySlotPrototype.find(
        item => item._id === value._id
      );
      setCopyslotsPrototypeData(selected?.Slots || []);
    }

    setDataItem({ ...dataItem, [e.target.name]: e.target.value });
  };

  const onCopySlot = async () => {
    setDisable(true);
    setStatusMessage("Copy Pasting Planning, please wait...");
    if (!isValid()) return;
    let payload = {
      Channel: { _id: dataItem.Channel._id, SID: dataItem.Channel.SID, FullChannelName: dataItem.Channel.FullChannelName },
      FromDate: utility.convertStringDatetoMilliseconds(dataItem.FromDate),
      ToDate: utility.convertStringDatetoMilliseconds(dataItem.ToDate),
      FromTime: utility.convertStringWithFramesToMilliseconds(dataItem.FromTime),
      ToTime: utility.convertStringWithFramesToMilliseconds(dataItem.ToTime),
      Slots: dataItem?.CopySlotPrototype?.Slots.map((item) => ({
        DayBuffer: parseInt(item.DayBuffer),
        SlotStartTime: item.SlotStartTime
      }))
    };

    console.log(payload)

    let res = await API.copyPastePlanningSlots(payload);
    console.log(res)
    if (res.success) {
      setDisable(false);
      props.planningLoading();
      setStatusMessage(lang.copy_slot_success_message);
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.copy_slot_success_message });
      props.closeForm();

    }
    else
    {
      setDisable(false);
      props.planningLoading();
      setStatusMessage(lang.copy_slot_success_message);
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }

  };

  const sectionStyle = {
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    padding: '14px',
    marginTop: '8px',
    background: '#fafbfc',
  };

  const sectionLabelStyle = {
    fontSize: '12px',
    fontWeight: 600,
    color: '#64748b',
    marginBottom: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  };

  const labelStyle = {
    fontSize: '13px',
    fontWeight: 500,
    color: '#333',
    marginBottom: '4px',
  };

  const onAddCopySlotPrototype = () => {
    setSelectedCopySlotPrototype(null);
    setShowCopySlotProtoType(true)
  };
  const onEditCopySlotPrototype = (item) => {
    console.log(item);
  setSelectedCopySlotPrototype(item);
  setShowCopySlotProtoType(true);
};

const emptyItem = { SID: 0 };
  return (
    <>
      <BossDialog
        title={lang.copy_slot_dialog_header}
        onClose={props.closeForm}
        width={"55vw"}
        showHeader={false}
      >

        <EditPageHeader onSubmit={onCopySlot} onCancel={props.closeForm} showTitle={true} saveButtonTitle={lang.apply_button_text} titleIcon={"clipboard"} title={lang.copy_slot_dialog_header} isLoading={disable} />
        <div className="row" style={{ marginTop: '4px' }}>
          {/* Left Panel */}
          <div className="col-6" style={{ borderRight: '1px solid #e2e8f0', paddingRight: '20px' }}>
            <div className="form-group" style={{ marginBottom: '10px' }}>
              <label style={labelStyle}>{lang.channel_label} <span style={{ color: '#ef4444' }}>*</span></label>
              <DropDownList
                style={{ backgroundColor: "white" }}
                data={channel}
                name="Channel"
                textField="FullChannelName"
                dataItemKey="_id"
                value={dataItem.Channel}
                onChange={onChange}
              />
            </div>

            {/* Slot Section */}
            <div style={sectionStyle}>
              <div style={sectionLabelStyle}>
                <i className="fa fa-clock-o" style={{ fontSize: '13px', color: '#94a3b8' }} />
                {lang.slot_label}
                 <div className='col text-right' style={{ color: 'gray', fontSize: '11px', marginTop: '2px', marginRight: '-10px' }}>
                  ({lang.selected_period_label} : {utility.getDaysAndHoursDifferenceWithTime(dataItem.FromDate, dataItem.ToDate,dataItem.FromTime, dataItem.ToTime, true,false).text})
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <label style={labelStyle}>{lang.from_date_label} <span style={{ color: '#ef4444' }}>*</span></label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    name="FromDate"
                    value={dataItem.FromDate}
                    onChange={onChange}
                  />
                </div>
                <div className="col-6">
                  <label style={labelStyle}>{lang.to_date_label} <span style={{ color: '#ef4444' }}>*</span></label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    name="ToDate"
                    value={dataItem.ToDate}
                    onChange={onChange}
                  />
                </div>
              </div>

              <div className="row" style={{ marginTop: '10px' }}>
                <div className="col-6">
                  <label style={labelStyle}>{lang.from_time_label}</label>
                  <TimePickerWithFormat
                    name="FromTime"
                    value={dataItem.FromTime}
                    onChange={onChange}
                  />
                </div>
                <div className="col-6">
                  <label style={labelStyle}>{lang.to_time_label}</label>
                  <TimePickerWithFormat
                    name="ToTime"
                    value={dataItem.ToTime}
                    onChange={onChange}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Right Panel */}
          <div className="col-6">
            <div className="form-group" style={{ marginBottom: '10px' }}>
              <label style={labelStyle}>{lang.copy_slot_prototype_label} <span style={{ color: '#ef4444' }}>*</span></label>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <DropDownList style={{ backgroundColor: "white", flex: 1 }}
                  data={copySlotPrototype}
                  name="CopySlotPrototype"
                  textField="Description"
                  dataItemKey="_id"
                  value={dataItem.CopySlotPrototype}
                  onChange={onChange}
                />
                <button type="button" title={lang.create_copy_slot_prototype_label} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                  style={{ height: "30px", minWidth: "32px" }} onClick={onAddCopySlotPrototype}><i className="fa-solid fa-plus fa-xs"></i>
                </button>
                {dataItem.CopySlotPrototype &&
                <button type="button" title={lang.edit_copy_slot_prototype_label} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                  style={{ height: "30px", minWidth: "32px" }} onClick={() => onEditCopySlotPrototype(dataItem.CopySlotPrototype)}><i className="fa-solid fa-pencil fa-xs"></i>
                </button>}
              </div>
            </div>
            <div style={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid #e2e8f0', marginTop: '8px' }}>
              <Grid data={copyslotsPrototypeData || []} style={{ height: 190 }}>
                <GridColumn field="DayBuffer" title={lang.day_buffer_column} />
                <GridColumn field="SlotStartTime" title={lang.start_time_column} cell={TimeCell} />
              </Grid>
            </div>
          </div>
        </div>
        {showCopySlotProtoType && <CopySlotPrototypeEditForm item={selectedCopySlotPrototype ?? emptyItem} cancelEdit={() => { setShowCopySlotProtoType(false); setSelectedCopySlotPrototype(null);}} refresh={() => {loadcombo()}} />}
      </BossDialog >
    </>
  );
};